import * as React from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  color: "black",
  outline: "none",
};

export default function ShareUI({ isShow, setShow }) {
  const handleClose = () => setShow(false);

  const linkedCopied = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success("Link Copied");
    setShow(false);
  };

  const socialRedirect = (type) => {
    const encodedUrl = encodeURIComponent(window.location.href);

    if (type === "facebook") {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        "_blank",
      );
    } else if (type === "whatsapp") {
      // ✅ BUG 5 FIX: lang=en parameter add kiya
      window.open(
        `https://api.whatsapp.com/send?text=${encodedUrl}&lang=en`,
        "_blank",
      );
    } else if (type === "linkedin") {
      // ✅ BUG 6 FIX: Naya LinkedIn sharing endpoint use kiya
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        "_blank",
      );
    } else if (type === "twitter") {
      window.open(
        `https://twitter.com/intent/tweet?url=${encodedUrl}`,
        "_blank",
      );
    } else if (type === "email") {
      window.open(
        `mailto:?subject=Job Opportunity&body=${encodedUrl}`,
        "_blank",
      );
    }
  };

  return (
    <div>
      <Modal
        open={isShow}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "20px",
            }}
          >
            <div style={{ fontSize: "18px", fontFamily: "sans-serif" }}>
              Share Job
            </div>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
          </div>
          <div style={{ width: "100%", border: "1px solid lightgray" }}></div>
          <div
            style={{
              padding: "20px",
              display: "flex",
              gap: "30px",
              justifyContent: "center",
            }}
          >
            <button
              style={{ border: "none", borderRadius: "6px" }}
              className="hoverEffect"
              onClick={() => socialRedirect("facebook")}
            >
              <img src="/facebook_1.png" height={70} />
              <div style={{ fontSize: "15px", color: "gray" }}>Facebook</div>
            </button>
            <button
              style={{ border: "none", borderRadius: "6px" }}
              className="hoverEffect"
              onClick={() => socialRedirect("whatsapp")}
            >
              <img src="/Whatapp.svg" height={70} />
              <div style={{ fontSize: "15px", color: "gray" }}>Whatsapp</div>
            </button>
            <button
              style={{ border: "none", borderRadius: "6px" }}
              className="hoverEffect"
              onClick={() => socialRedirect("twitter")}
            >
              <img src="/twitter.svg" height={70} />
              <div style={{ fontSize: "15px", color: "gray" }}>Twitter</div>
            </button>
            <button
              style={{ border: "none", borderRadius: "6px" }}
              className="hoverEffect"
              onClick={() => socialRedirect("linkedin")}
            >
              <img src="/linkedin.svg" height={70} />
              <div style={{ fontSize: "15px", color: "gray" }}>Linkedin</div>
            </button>
            <button
              style={{ border: "none", borderRadius: "6px" }}
              className="hoverEffect"
              onClick={() => socialRedirect("email")}
            >
              <img src="/Mail.svg" height={70} />
              <div style={{ fontSize: "15px", color: "gray" }}>Email</div>
            </button>
          </div>
          <div
            style={{
              padding: "20px",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              paddingTop: "15px",
            }}
          >
            <div
              style={{
                border: "1px solid lightgray",
                padding: "5.5px 14px",
                color: "gray",
                width: "100%",
              }}
            >
              {window.location.href}
            </div>
            <Button
              variant="contained"
              startIcon={<ContentCopyIcon />}
              onClick={linkedCopied}
            >
              Link
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
